import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { setupManager } from '@lib/session';
import { newApolloClient, setClient } from '@lib/apollo';
import { ApolloProvider } from '@apollo/client';
import { createRouter } from './router';
import initializeFaro from './faro';
import { register as registerServiceWorker } from './sw-register';
import { withFaroRouterInstrumentation } from '@grafana/faro-react';
// import { addListeners as addWebPushListeners } from '@hks/web-push';
// import '@/index.css';

initializeFaro();
// addWebPushListeners(sessionManager, client);

registerServiceWorker();
const sessionManager = setupManager();
const client = newApolloClient({ fetch: sessionManager.fetch.bind(sessionManager) });
setClient(client);

const router = withFaroRouterInstrumentation(createRouter());

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ApolloProvider client={client}>
      <RouterProvider router={router} />
    </ApolloProvider>
  </React.StrictMode>,
);
